export const DASH_LINKS = {
    assessment_excusals:
        process.env.NODE_ENV !== "production"
            ? "https://dev-student-excusals.dcsdk12.org/home" // /<studentNumber>
            : "https://student-excusals.dcsdk12.org/home",
    echeckin:
        process.env.NODE_ENV !== "production"
            ? "https://dev-echeckin-parent.dcsdk12.org/echeckin" // /<studentNumber>
            : "https://echeckin-parent.dcsdk12.org/echeckin",
    epr:
        process.env.NODE_ENV !== "production" ? "https://dev-reportcard.dcsdk12.org" : "https://reportcard.dcsdk12.org",
    epr_archive: "/epr-archive",
    guardian: process.env.NODE_ENV !== "production" ? "https://dev-engaged.dcsdk12.org" : "https://engaged.dcsdk12.org",
    legacy: process.env.NODE_ENV !== "production" ? "https://twpp-engaged.dcsdk12.org" : "https://engaged.dcsdk12.org",
    open_enrollment:
        process.env.NODE_ENV !== "production"
            ? "https://dev-open-enrollment-parent.dcsdk12.org" // /home, /view/<studentNumberr>, /edit/<oeStudentKey>, /school-choice/<oeStudentKey>
            : "https://open-enrollment-parent.dcsdk12.org",
    transportation:
        process.env.NODE_ENV !== "production"
            ? "https://dev-transportation-parent.dcsdk12.org/transportation" // /<studentNumber>
            : "https://transportation-parent.dcsdk12.org/transportation"
};
